import { iif, MonoTypeOperatorFunction, Observable, throwError, timer } from 'rxjs';
import { concatMap, retryWhen } from 'rxjs/operators';

/**
 * This operator retries source observable with exponential delays, like 1s, 2s, 4s, 8s, 16s, ..
 */
export function retry<T>({
  maxRetries = 3,
  scaling = 1000,
}: { maxRetries?: number; scaling?: number } = {}): MonoTypeOperatorFunction<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      retryWhen<T>((errors) =>
        errors.pipe(
          concatMap((error, i) => iif(() => i < maxRetries, timer(Math.pow(2, i) * scaling), throwError(error)))
        )
      )
    );
}
